import { jsx as _jsx } from "react/jsx-runtime";
import { Heading as ChakraHeading } from '@chakra-ui/react';
export function HeadingTitle(_ref) {
  var content = _ref.content,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'text.primary' : _ref$color;
  return /*#__PURE__*/_jsx(ChakraHeading, {
    fontWeight: "bold",
    color: color,
    fontSize: "title",
    textAlign: "center",
    w: ['100%'],
    mb: "2",
    children: content
  });
}